// extracted by mini-css-extract-plugin
export default {"wrapper":"doughnut-chart_wrapper__qpcy8","total":"doughnut-chart_total__tn6CJ","text":"doughnut-chart_text__VwCzl","result":"doughnut-chart_result__IquV3"};